import { render, staticRenderFns } from "./RecuperarSenha.vue?vue&type=template&id=1d498750"
import script from "./RecuperarSenha.vue?vue&type=script&lang=ts"
export * from "./RecuperarSenha.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports